import { render, staticRenderFns } from "./OptionGroupBox.vue?vue&type=template&id=13f511bb&"
import script from "./OptionGroupBox.vue?vue&type=script&lang=ts&"
export * from "./OptionGroupBox.vue?vue&type=script&lang=ts&"
import style0 from "./OptionGroupBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f511bb')) {
      api.createRecord('13f511bb', component.options)
    } else {
      api.reload('13f511bb', component.options)
    }
    module.hot.accept("./OptionGroupBox.vue?vue&type=template&id=13f511bb&", function () {
      api.rerender('13f511bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/OptionGroupBox.vue"
export default component.exports